import { Key, Entity } from '@briebug/ngrx-auto-entity';

@Entity({ modelName: 'JobPlanManaged' })
export class JobPlanManaged {
  @Key id: string;
  manager: string;
  jobPlan: string;
  delta: number;
}
